export default __webpack_public_path__ + "static/media/check-white.61ced77a.svg";